import { render, staticRenderFns } from "./VueCarouselWrapper.vue?vue&type=template&id=1ef3fe69&"
import script from "./VueCarouselWrapper.vue?vue&type=script&lang=ts&"
export * from "./VueCarouselWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./VueCarouselWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports